import BaseXMLGenerator from './xlsx-tableexport-generator.js';

var XMLGenerator = new BaseXMLGenerator();
XMLGenerator.baseGenerate = XMLGenerator.generate
XMLGenerator.generate = function (vm, datas) {
    var rows = []
    for (var data of datas) {
        var row = []

        let county = (vm.$store.getters.countries.find(o => o.ID === data.CountyID) || {})
        row.push(data.Name)
        row.push(county.Name || '')

        rows.push(row)
    }
    let headerList = ['客戶名稱', '所在縣市']
    return this.baseGenerate(rows, headerList)
}

export default XMLGenerator;